export default "__VITE_ASSET__DZg1ECvx__"